import React from 'react';
import { useBuild } from '../../contexts/BuildContext';
import QueryModes from '../../search/QueryModes';

// Shared by all chain-specific trade-event aliases:
//   hyperliquid-trades, polymarket-trades, base-trades, ethereum-trades, solana-trades
// Each is the `alpha-trade-events-<chain>` index. The doc shape is uniform
// across chains (per the alpha-source schema): trade events with size_usd,
// price_usd, direction, wallet_address, transaction_hash, timestamp, ...
const SORT_OPTIONS = [
  { id: 'timestamp', label: 'timestamp' },
  { id: 'indexed_at', label: 'indexed_at' },
  { id: 'size_usd', label: 'size_usd' },
  { id: 'price_usd', label: 'price_usd' },
  { id: 'token_bought_amount', label: 'token_bought_amount' },
  { id: 'token_sold_amount', label: 'token_sold_amount' },
  { id: 'volume_usd_24h', label: 'volume_usd_24h' },
  { id: 'price_diff_pct_1d', label: 'price_diff_pct_1d' },
  { id: 'holders_count', label: 'holders_count' },
  { id: 'null', label: 'None' },
];

const FILTER_TYPE_OPTIONS = [
  { id: 'item_ids', label: 'Event / Transaction IDs' },
  { id: 'trade_filters', label: 'Wallet / Token / Direction' },
  { id: 'date', label: 'Date Range' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
  { id: 'author_in_app_users', label: 'In-App Users (your pushed wallets)' },
];

const TradeEventsQuery = () => {
  const { selectedIndex } = useBuild();
  return (
    <QueryModes
      source={selectedIndex}
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={FILTER_TYPE_OPTIONS}
    />
  );
};

export default TradeEventsQuery;
